<template>
<v-card color="black" :style="dialogStyle">
  <div @click.stop="$emit('close')" style="position: fixed; height: 100%; width: 100%"></div>
  <v-btn icon flat dark color="grey" @click="$emit('close')" style="position:absolute;top:0px;right:0px;">
    <v-icon>close</v-icon>
  </v-btn>
  <v-btn color="secondary" dark fixed bottom right fab :href="src">
    <v-icon>cloud_download</v-icon>
  </v-btn>
</v-card>
</template>

<script>
export default {
  name: 'CameraView',
  props: {
    src: {
      type: String
    }
  },
  computed: {
    dialogStyle() {
      return `background: url("${this.src}") center center / contain no-repeat; height: ${window.innerHeight}px;`;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cast/CameraView.vue